import { useAction } from "@/hooks/shared";
import { listCompaniesHandler } from "@/services";

export const useListCompanies = () => useAction(listCompaniesHandler);
